export enum PeriodOptions {
    Day = 'day',
    Week = 'week',
    Month = 'month',
}
